const PlayIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16.0003 1.66602C8.08424 1.66602 1.66699 8.08327 1.66699 15.9993C1.66699 23.9154 8.08424 30.3327 16.0003 30.3327C23.9164 30.3327 30.3337 23.9154 30.3337 15.9993C30.3337 8.08327 23.9164 1.66602 16.0003 1.66602Z"
        fill="white"
      />
      <path
        d="M18.1185 12.048L18.0096 11.9807C17.134 11.439 16.3994 10.9845 15.7899 10.7022C15.1718 10.4159 14.4671 10.1999 13.7321 10.4267C13.2463 10.5766 12.8147 10.8579 12.4739 11.2323C11.978 11.7771 11.8146 12.4891 11.7407 13.2007C11.667 13.9098 11.667 14.8259 11.667 15.9416V16.0562C11.667 17.1718 11.667 18.088 11.7407 18.7971C11.8146 19.5087 11.978 20.2207 12.4739 20.7654C12.8147 21.1398 13.2463 21.4212 13.7321 21.5711C14.4671 21.7978 15.1718 21.5818 15.7899 21.2956C16.3994 21.0133 17.134 20.5588 18.0096 20.0171L18.1184 19.9498C19.0274 19.3875 19.7852 18.9187 20.3343 18.482C20.8996 18.0323 21.3975 17.5009 21.5765 16.7602C21.6972 16.2609 21.6972 15.7369 21.5765 15.2376C21.3975 14.4969 20.8996 13.9654 20.3343 13.5158C19.7852 13.079 19.0274 12.6103 18.1185 12.048Z"
        fill="white"
      />
    </svg>
  );
};

export default PlayIcon;
